<div class="tasks-list subtasks-container">
    <div class="task-row subtask-row" *ngFor="let subtask of subtasks">
        <div class="task-main subtask-main">
            <input type="checkbox" class="task-checkbox subtask-checkbox" [checked]="isChecked(subtask)" (change)="toggleDone(subtask)">

            <input *ngIf="editingTaskId === subtask._id; else taskTextDisplay" class="task-text-input" type="text"
                [(ngModel)]="editingTaskText" (keyup.enter)="saveTextEdit(subtask)" (keyup.escape)="cancelTextEdit()"
                (blur)="saveTextEdit(subtask)">
            <ng-template #taskTextDisplay>
                <span class="task-text subtask-title editable" [class.done]="isChecked(subtask)"
                    (click)="startTextEdit(subtask)">{{ subtask.title }}</span>
            </ng-template>

            <ng-container *ngIf="confirmingDeleteId === subtask._id; else taskActions">
                <span class="confirm-label">{{ 'permit.manage.subtasks.delete_confirm' | translate }}</span>
                <button type="button" class="confirm-yes" (click)="executeDelete(subtask._id)">{{ 'permit.manage.common.delete' | translate }}</button>
                <button type="button" class="confirm-no" (click)="confirmingDeleteId = null">{{ 'permit.manage.common.cancel' | translate }}</button>
            </ng-container>

            <ng-template #taskActions>
                <button type="button" class="due-pill" [class.has-date]="!!subtask.dueDate"
                    [class.due-past]="subtask.dueDate && getDueStatus(subtask.dueDate) === 'past'"
                    [class.due-soon]="subtask.dueDate && getDueStatus(subtask.dueDate) === 'soon'"
                    (click)="$event.stopPropagation(); openDueDatePicker(subtask._id)">
                    <mat-icon>calendar_today</mat-icon>
                    <span>{{ subtask.dueDate ? formatDueDate(subtask.dueDate) : ('permit.manage.subtasks.due_date' | translate) }}</span>
                </button>

                <button type="button" class="task-assignee subtask-assignee" [class.assigned]="!!subtask.assignedTo"
                    [class.loading]="assigningSubtaskId === subtask._id" [matTooltip]="getAssigneeName(subtask.assignedTo)"
                    [attr.aria-label]="getAssigneeName(subtask.assignedTo) || ('permit.manage.subtasks.assigned_to' | translate)"
                    (click)="openAssigneeMenu($event, subtask._id)">
                    <ng-container *ngIf="subtask.assignedTo; else noAssignee">
                        <img *ngIf="getAssigneePicture(subtask.assignedTo)" [src]="getAssigneePicture(subtask.assignedTo)" alt="">
                        <span *ngIf="!getAssigneePicture(subtask.assignedTo)" class="initials">{{ getAssigneeInitials(subtask.assignedTo) }}</span>
                    </ng-container>
                    <ng-template #noAssignee><mat-icon class="person-add-icon">person_add</mat-icon></ng-template>
                </button>

                <button type="button" class="delete-btn" (click)="$event.stopPropagation(); confirmingDeleteId = subtask._id">
                    <mat-icon>close</mat-icon>
                </button>
            </ng-template>
        </div>

        <div class="task-meta" *ngIf="isChecked(subtask) && subtask.completedAt">
            {{ 'permit.manage.subtasks.completed_at' | translate }} {{ subtask.completedAt | date:'medium' }}
        </div>
    </div>

    <div class="task-row new-task-row subtask-row subtask-add-row" *ngIf="isAdding">
        <div class="task-main subtask-main">
            <input type="checkbox" class="task-checkbox subtask-checkbox" disabled>
            <input #newTaskInput type="text" class="task-input subtask-input"
                [placeholder]="'permit.manage.subtasks.add_placeholder' | translate" [(ngModel)]="newDescription"
                (keyup.enter)="addSubtask()" (keyup.escape)="dismissAdding()">
            <button type="button" class="due-pill" [class.has-date]="!!newDueDate"
                (click)="$event.stopPropagation(); openDueDatePicker('new')">
                <mat-icon>calendar_today</mat-icon>
                <span>{{ newDueDate ? formatDueDate(newDueDate) : ('permit.manage.subtasks.due_date' | translate) }}</span>
            </button>
            <button type="button" class="task-assignee subtask-assignee" [class.assigned]="!!selectedAssignee"
                [attr.aria-label]="selectedAssignee?.name || ('permit.manage.subtasks.assigned_to' | translate)"
                (click)="openAssigneeMenu($event, 'new')">
                <ng-container *ngIf="selectedAssignee; else noNewAssignee">
                    <img *ngIf="selectedAssignee.picture" [src]="selectedAssignee.picture" alt="">
                    <span *ngIf="!selectedAssignee.picture" class="initials">{{ selectedAssignee.initials }}</span>
                </ng-container>
                <ng-template #noNewAssignee><mat-icon class="person-add-icon">person_add</mat-icon></ng-template>
            </button>
            <button type="button" class="create-btn" [disabled]="!newDescription.trim() || isCreating" (click)="addSubtask()">
                {{ 'permit.manage.subtasks.create' | translate }}
            </button>
        </div>
    </div>

    <button type="button" class="add-task-btn add-subtask-btn" *ngIf="!isAdding" (click)="startAdding()">
        <mat-icon>add</mat-icon>
        {{ 'permit.manage.subtasks.add' | translate }}
    </button>
</div>

<input class="date-picker-hidden" [matDatepicker]="sharedDuePicker" (dateChange)="onDueDateChange($event)" readonly>
<mat-datepicker #sharedDuePicker>
    <mat-datepicker-actions>
        <button mat-button matDatepickerCancel (click)="clearDueDate()">{{ 'permit.manage.subtasks.due_date_clear' | translate }}</button>
        <button mat-raised-button color="primary" matDatepickerApply>OK</button>
    </mat-datepicker-actions>
</mat-datepicker>

<app-subtask-assignee-menu #assigneeMenu (assigneeSelect)="onAssigneeSelected($event)" (close)="activeSubtaskId = null"></app-subtask-assignee-menu>
